import React, { Component, useState } from "react";
import {
  DKLabel,
  showLoader,
  removeLoader,
  DKListPicker,
  DKIcon,
  DKIcons,
} from "deskera-ui-library";


/*
PROPS:
 - className
 - data ([{id, name}])
 - selectedId (id: selected Segment)
 - onViewChange
*/

const ViewToggle = (props) => {

    const [selectedId, setView] = useState(props.selectedView)

    const onChange = (data, index) => {
      setView(data.id);
      if (props.onViewChange) {
        props.onViewChange(data, index);
      }
    };

    return (
      <div className=" d-flex toogle-view">
        {props.data.map((segment, index) => (
          <div
            id={`segment${segment.id}`}
            key={`segment-${index}`}
            data-index={index}
            onClick={() => onChange(segment, index)}
            className={`cursor-hand ${
              selectedId === segment.id ? "bg-app text-white fw-m" : "bg-white"
            } ${index === 0 ? "segment-ctrl-first" : "segment-ctrl-last"}
                align-items-center d-flex`}
            style={{
              // borderLeft: `${index ? "1px solid lightgray" : "none"}`,
              border: `${
                selectedId === segment.id ? "" : "1px solid lightgrey"
              }`,
              // height: 30,
            }}
          >
            <DKIcon
              src={
                selectedId === segment.id
                  ? segment.icon
                  : segment.unselectedIcon
              }
              className="ic-s"
              style={{ padding: "8px" }}
            />
            {/* <DKLabel
                  className={"p-h-l p-v-s cursor-hand "}
                  style={{
                    overflowWrap: "unset",
                    whiteSpace: "nowrap",
                    filter: "yellow"
                  }}
                  text={segment.name}
                /> */}
          </div>
        ))}
      </div>
    );
}

export default ViewToggle;